module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [(_vm.returnToEmptyDeviceId) ? _c('span', [_vm._v("退回不同批號藥物，將退至空藥盒")]) : (_vm.currentDrugInDevice !== null && _vm.currentSystem.settings.return_to_original_cmpn) ? _c('span', [_c('span', [_vm._v("藥盒數量/上限: " + _vm._s(_vm.currentDrugInDevice.stock) + " / " + _vm._s(_vm.currentDrugInDevice.max_stock) + " ")]), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("藥物總數量/上限: " + _vm._s(_vm.$store.state.drug.selectedDrugTotalAmount) + " /" + _vm._s(_vm.$store.state.drug.selectedDrugTotalMax) + " ")])]) : _c('span', [_vm._v("未設定退回原藥盒")])]), (_vm.currentProgress === 'selectReason') ? _c('ConfirmReason', {
    on: {
      "setReason": _vm.getReason
    }
  }) : _vm._e(), _c('TextInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentProgress === 'medIdInput'),
      expression: "currentProgress === 'medIdInput'"
    }],
    attrs: {
      "inputLabel": '輸入病歷號',
      "defaultContent": _vm.medRecordId
    },
    on: {
      "setText": _vm.getMedId
    }
  }), _c('TextInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentProgress === 'setPatchNo'),
      expression: "currentProgress === 'setPatchNo'"
    }],
    attrs: {
      "inputLabel": '確認批號',
      "defaultContent": _vm.patchNo
    },
    on: {
      "setText": _vm.getPatchNo
    }
  }), (_vm.currentProgress === 'setExpiredDate') ? _c('ConfirmExpiredDate', {
    attrs: {
      "defaultExpirationDate": _vm.defaultExpiredDate,
      "editable": _vm.expiredDateEditable
    },
    on: {
      "setExpirationDate": _vm.getExpiredDate
    }
  }) : _vm._e(), (_vm.currentProgress === 'setStorage') ? _c('ConfirmStorage', {
    attrs: {
      "inputLabel": '設定退藥數量',
      "defaultAmount": _vm.defaultReturnAmount
    },
    on: {
      "setNum": _vm.getStorage
    }
  }) : _vm._e(), (_vm.currentProgress === 'rxCheck') ? _c('RxCheckBarcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), (_vm.currentProgress === 'action') ? _c('ActionWrap', {
    attrs: {
      "amountPayload": _vm.amountPayload,
      "actionProgress": _vm.actionProgress,
      "returnToEmptyDeviceId": _vm.returnToEmptyDeviceId,
      "actionRecorded": _vm.actionRecorded
    },
    on: {
      "setActionData": _vm.getActionData,
      "finishAction": _vm.finishAction
    }
  }) : _vm._e(), (_vm.showPatchConfirmModal) ? _c('ConfirmModal', {
    attrs: {
      "message": '輸入批號與目前藥盒不同，是否繼續退藥？'
    },
    on: {
      "response": _vm.confirmPatchChoice
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02623d1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnDrugFlow/ConfirmFlow.vue
// module id = 1366
// module chunks = 1